import React, { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useOnClickOutside from 'use-onclickoutside'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faClipboardList, faList, faCog, faStar, faInfo, faUser, faQuestion } from '@fortawesome/free-solid-svg-icons'
import { push } from 'connected-react-router'
import { NavItem } from '../ui/molecules/NavItem'

const Nav = ({ navOpen, onClose }) => {
  const ref = useRef(null)
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(store => store.session.isAuthenticated)
  const user = useSelector(store => store.user.user)

  const [premiumUrl, setPremiumUrl] = useState('/premium')

  useEffect(() => {
    if (isAuthenticated && user && user.delinquent) {
      setPremiumUrl('/premium/renew')
    }
  }, [user, isAuthenticated])

  useOnClickOutside(ref, e => {
    if (navOpen && e.target.id !== 'navControl') {
      onClose()
    }
  })

  const handleNavClick = (path) => {
    onClose()
    dispatch(push(path))
  }

  return (
    <nav
      ref={ref}
      className={`lg:flex w-32 flex-col z-50 min-h-screen items-center bg-gray-900 py-4 text-white ${
        navOpen ? 'flex' : 'hidden'
      }`}
    >
      <NavItem path="/new" title="New Request" icon={faPlus} onClick={() => handleNavClick('/new')} />
      {!isAuthenticated && <NavItem title="Your Account" icon={faUser} onClick={() => handleNavClick('/sign-in')} />}
      {isAuthenticated && <NavItem title="Requests" icon={faList} onClick={() => handleNavClick('/')} />}
      {isAuthenticated && <NavItem title="Settings" icon={faCog} onClick={() => handleNavClick('/settings')} />}

      <NavItem title="Go Premium" icon={faStar} yellow onClick={() => handleNavClick(premiumUrl)} />
      <NavItem title="Questions" icon={faQuestion} onClick={() => handleNavClick('/faq')} />

      <NavItem title="About" icon={faInfo} onClick={() => handleNavClick('/about')} />
      <NavItem title="Logs" icon={faClipboardList} onClick={() => handleNavClick('/logs')} />
    </nav>
  )
}

export default Nav
